// Components
import Icon from './Icon';

// Utils
import { convertEntities } from '../utils/helpers';

const Dealer = ( { data } ) => {
	const { distance, content, id, address } = data;
	const { address: currentAddress } = address;
	const { title, email, phone, website, link, subheading, extrafield1, extrafield2 } = content;

	let unit;
	if ( window.location.href.indexOf( '/us/' ) > -1 || window.location.href.indexOf( '/demo/' ) > -1 ) {
		unit = ' miles';
	} else {
		unit = ' km';
	}

	return (
		<div className="col-12 col-m-6 col-l-4">
			<article id={ `post-${ id }` } className="archive-item archive-item--dealer">
				<figure className="archive-item__figure">
					<span className="archive-item__distance">{ distance + unit }</span>
				</figure>
				<div className="archive-item__content">
					<a href={ link }>
						<h3 className="archive-item__heading">{ convertEntities( title ) }</h3>
					</a>
					<ul className="archive-item__data">
						{ currentAddress && ( <li className="archive-item__data-item"><Icon name="map-pin" />{ currentAddress }</li> ) }
						{ phone && ( <li className="archive-item__data-item"><Icon name="phone" />{ phone }</li> ) }
						{ email && ( <li className="archive-item__data-item"><Icon name="email" /><a href={ `mailto:${ email }` }>{ email }</a></li> ) }
						{ website && ( <li className="archive-item__data-item"><Icon name="globe" /><a href={ website } target="_blank" rel="noopener noreferrer">{ website }</a></li> ) }
					</ul>
					{ subheading && ( <h4>{ subheading }</h4> ) }
					{ ! subheading && extrafield1 && ( <br /> ) }
					<ul className="archive-item__data">
						{ extrafield1 && ( <li className="archive-item__data-item"><Icon name="ac-info" />{ extrafield1 }</li> ) }
						{ extrafield2 && ( <li className="archive-item__data-item"><Icon name="ac-info" />{ extrafield2 }</li> ) }
					</ul>
				</div>
			</article>
		</div>
	);
};

export default Dealer;
